import { render, staticRenderFns } from "./milestone.vue?vue&type=template&id=11960f80&scoped=true"
import script from "./milestone.vue?vue&type=script&lang=js"
export * from "./milestone.vue?vue&type=script&lang=js"
import style0 from "./milestone.vue?vue&type=style&index=0&id=11960f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11960f80",
  null
  
)

export default component.exports